export default "__VITE_ASSET__s$oN3hfP__"